import RenderIf from "common/components/RenderIf";
import RestrictedComponent from "common/components/RestrictedComponent";
import Skeleton from "common/components/ui/Skeleton";
import type {
  AgencySubscription,
  RentedSubscription,
  Subscription,
} from "common/types";

import { formatBillingDate } from "../../../../utils";
import SubscriptionPaymentMethod from "./SubscriptionPaymentMethod";

import type { ReactNode } from "react";

interface SubscriptionInfoProps {
  subscription:
    | Subscription
    | RentedSubscription
    | AgencySubscription
    | undefined;
  isLoading: boolean;
  buttonComponent: ReactNode;
}

export default function SubscriptionInfo({
  isLoading,
  subscription,
  buttonComponent,
}: SubscriptionInfoProps) {
  let billingDate: string;
  if (subscription) {
    billingDate =
      subscription.status === "non_renewing"
        ? formatBillingDate(subscription.cancelled_at * 1000)
        : formatBillingDate(subscription.next_billing * 1000);
  }

  return (
    <div className="flex flex-col lg:flex-row gap-x-2 gap-y-4 md:gap-y-0 lg:items-center [&>button,&>.flex]:ml-auto max-lg:[&>button]:mt-9 empty:hidden">
      {subscription && subscription.status !== "cancelled" && (
        <div className="flex w-full flex-col-reverse gap-3 lg:gap-2 lg:flex-row lg:items-center">
          {isLoading ? (
            <Skeleton className="h-5 w-48" />
          ) : (
            <RenderIf condition={!!billingDate}>
              <p className="text-sm-medium text-black-500">
                {subscription?.status === "non_renewing"
                  ? "Ends"
                  : "Next billing"}{" "}
                on {billingDate}
              </p>
            </RenderIf>
          )}

          {!!subscription && (!!billingDate || isLoading) && (
            <span className="inline-flex max-lg:w-full lg:h-3 lg:border-r max-lg:border-t-2 border-black-200 max-lg:border-dotted" />
          )}

          {/* Payment method - only visible if subscription exists */}
          {!!subscription && (
            <SubscriptionPaymentMethod subscriptionId={subscription.id} />
          )}
        </div>
      )}

      <RestrictedComponent visibleForPermissions={["billing_full"]}>
        {buttonComponent}
      </RestrictedComponent>
    </div>
  );
}
